import { createSelector } from 'reselect';
import { sportOccupationsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const sportOccupationsYearsSelector = createSelector([sportOccupationsSelector], (sportOccupations) =>
  extractDatesFromNestedItems(
    [sportOccupations.content],
    [
      {
        type: 'range',
        startField: 'startDate',
        endField: 'endDate',
      },
    ],
  ),
);
